import { Injectable } from '@angular/core';

import { NewsRepository } from '../repositories/news-repository';
import { NewsEventProvider } from './events/news-event.provider';
import { NewsCreated, NewsDeleted, NewsUpdated } from './events/news-events';
import { News } from './news';

@Injectable()
export class NewsCommands {
  constructor(
    private newsRepository: NewsRepository,
    private newsEventProvider: NewsEventProvider,
  ) {
    // Nada
  }

  async findAllNews(lastId: string | undefined): Promise<News[]> {
    return this.newsRepository.findAll(lastId);
  }

  async findAllAfterDate(after: Date): Promise<News[]> {
    return this.newsRepository.findAllAfterDate(after);
  }

  async findLastTwoNews(): Promise<News[]> {
    return this.newsRepository.findLastTwoNews();
  }

  async save(news: News): Promise<News> {
    if (news.id && news.id.toString() !== 'new') {
      const updated = await this.newsRepository.save(news);
      this.newsEventProvider.dispatch(new NewsUpdated(updated));
      return updated;
    } else {
      try {
        const created = await this.newsRepository.create(news);
        this.newsEventProvider.dispatch(new NewsCreated(created));
        return created;
      } catch (e) {
        console.error('🔴', e);
        throw e;
      }
    }
  }

  async delete(news: News): Promise<void> {
    await this.newsRepository.delete(news.id.toString());
    this.newsEventProvider.dispatch(new NewsDeleted(news));
  }
}
